import React, { useEffect, useState } from 'react';
import Modal from 'src/component/Global/Modal';
import NavigateToPDP from 'src/component/Global/Product/NavigateToPDP';
import DisplayLongDescriptionAndVariantMFRName from 'src/component/Product/DisplayLongDescriptionAndVariantMFRName';
import { useCartStore } from 'src/hooks/cart';
import Constants from 'src/support/Constants';
import Helper from 'src/support/Helper';

const PriceMisMatchBackOrder = (props) => {
    const [status, SetStatus] = useState(false);
    const { single_product, PRODUCT_PRICE, PRODUCT_INVENTORY } = props.data;
    const [{ }, { }, { ADD_TO_CART }] = useCartStore();


    useEffect(() => {
        SetStatus(true)
    }, []);

    const onHide = () => {
        SetStatus(false)
    };

    const updateQty = async () => {
        const v = single_product;
        let param = {
            "partNumber": v.ERPPartNumber,
            "assetURL": v.assetURL,
            "ItemNumber": v.ItemNumber,
            "ManufacturerPartNumber": v.ManufacturerPartNumber,
            "ERPMFRPartNumber": v.ERPMFRPartNumber,
            "quantity": PRODUCT_PRICE.demandQuantityOut,
            "totalQuantity": v.totalQuantity, //added
            "backOrderQuantity": v.backOrderQuantity,
            "subtotal": v.subtotal,
            "manufacturerCode": v.ManufacturerCode,
            "manufacturerName": v.ManufacturerName,
            "erpManufacturerCode": v.ERPManufacturerCode,
            "erpManufacturerName": v.ERPManufacturerName,
            "cpn": v.cpn,
            "cpnType": v?.CustomerPartNumbers?.length > 0 ? Constants.cpnTypes.CPN : Constants.cpnTypes.MANUALCPN,
            "manualCPN": ''
        }
        if (param.cpnType === Constants.cpnTypes.MANUALCPN) {
            param.manualCPN = ''
        }
        // await new CartRepository().addToCartServer(param, props.data.isManuallyAddCart);
        await ADD_TO_CART(param, props.data.isManuallyAddCart)

        if (props.data.productAddedToCartCallback) {
            props.data.productAddedToCartCallback();
        }
        if (props.data?.isFrom) {
            Helper.setEvars(v?.ERPMFRPartNumber, "Add to Cart clicked from " + props.data?.isFrom)
            // if (window?.digitalData) {
            //     if (!window?.digitalData?.transaction) {
            //         window.digitalData.transaction = {}
            //     }
            //     window.digitalData.event.eventinfo.events = "Add to Cart clicked from " + props.data?.isFrom;
            //     window.digitalData.transaction.items = v?.ERPMFRPartNumber;
            // }
        }

        onHide(false);
    }

    return (
        <Modal show={status} onHide={() => { onHide() }}>
            <div className="avnet-modal modal-680">
                <div className="avnet-modal-inner">
                    {/* Modal Header */}
                    <button type="button" className="close" data-dismiss="modal"
                        onClick={() => { onHide() }}>×
                    </button>
                    <div className="modal-header justify-content-center mt-0">
                        <h3 className="pcn-modal-heading">Price Mismatch and Inventory Alert</h3>
                    </div>
                    <div className="m-4 mt-0 mb-0">
                        <div className="justify-content-start">
                            There is a mismatch between selected Quantity and the available price tier. <br />
                            We currently do not have sufficient inventory for the following item(s).<br />
                            Please contact your local sales officer for a lower quantity pricing.<br /><br />

                            Confirm the adjusted quantity and backorder by clicking the <b>Yes</b> button below.
                        </div>
                    </div>
                    <div className="modal-body">
                        <div className="inventory-table price-mismatch-table">
                            <table className="table table-outline rounded-0">
                                <thead>
                                    <tr className="bg-light">
                                        <th colSpan={4} className='text-center'>Price Mismatch</th>
                                    </tr>
                                    <tr>
                                        <th className="border-0 text-none font-12">Product(s)</th>
                                        <th className="border-0 text-none font-12">Requested Qty</th>
                                        <th className="border-0 text-none font-12">Adjusted Qty</th>
                                        <th className="border-0 text-none font-12">Unit Price</th>
                                    </tr>
                                </thead>
                                <tbody className="border-top-0">

                                    <tr>
                                        <td className="align-middle">
                                            <div className="inventory-product-info">
                                                <div className="inventory-product-name">
                                                <NavigateToPDP data={{
                                                    ManufacturerName: single_product?.ManufacturerName,
                                                    ERPMFRPartNumber: single_product?.ERPMFRPartNumber,
                                                    ItemNumber: single_product?.ItemNumber,
                                                }}  >
                                                        <b className='text-black'>{single_product.ERPMFRPartNumber}</b>
                                                    </NavigateToPDP>
                                                </div>
                                                <div className="inventory-product-by">
                                                    <DisplayLongDescriptionAndVariantMFRName
                                                        currentProduct={single_product} />
                                                    <span className='astric mb-1'>See inventory Alert for this item</span>
                                                </div>
                                            </div>
                                        </td>
                                        <td className="align-top">
                                            <span>{single_product.quantity}</span>
                                        </td>
                                        <td className="align-top">
                                            <span>{PRODUCT_PRICE.demandQuantityOut}</span>
                                        </td>
                                        <td className="align-top">
                                            <span>{Helper.getFormatNumber(Number(PRODUCT_PRICE.marketPrice), window.mct, window.mcs, 5)}</span>
                                        </td>
                                    </tr>
                                    <tr className='bg-light'><th colSpan={4} className='text-center'>Inventory Alert</th></tr>
                                    <tr>
                                        <td colSpan={2}></td>
                                        <th>Adjusted Qty</th>
                                        <th>Backorder Qty</th>
                                    </tr>
                                    <tr>
                                        <td colSpan={2}>
                                            <div className="inventory-product-stock"><b>In
                                                Stock: {PRODUCT_INVENTORY.quantity}</b>
                                            </div>
                                            <div className="inventory-product-lead">Lead Time From
                                                Supplier: {PRODUCT_INVENTORY.plifz ? PRODUCT_INVENTORY.plifz : 'Not Available'}
                                            </div>
                                        </td>
                                        <td>
                                            <span>{PRODUCT_PRICE.demandQuantityOut}</span>
                                        </td>
                                        <td>
                                            <span>{PRODUCT_PRICE.demandQuantityOut}</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div className='text-end'><p>Item Subtotal: (EUR) <strong>€577,60</strong> </p> </div>

                        </div>
                    </div>
                    {/* Modal footer */}
                    <div className="modal-footer justify-content-center">
                        <div className="modal-footer-actions">
                            <button type="button" className="bs5 btn btn-secondary btn-sm w145"
                                data-bs-toggle="modal" data-bs-target="#InventoryModal"
                                onClick={() => { onHide(false) }}>
                                No
                            </button>
                            <button type="button" className="bs5 btn btn-primary btn-sm w145"
                                onClick={async () => { await updateQty() }}
                                data-bs-toggle="modal" data-bs-target="#InventoryModal">
                                Yes
                            </button>

                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    )
}

export default PriceMisMatchBackOrder;